<div class="overflow-hidden">
    <div class="flex">
        <div class="flex  gap-8 flex-nowrap w-full " [ngClass]="animationClass">
           <ng-content></ng-content>
        </div>
    </div>
</div>